// extracted by mini-css-extract-plugin
var _1 = "tjs-obscure-overlay__bottomOverlay";
var _2 = "tjs-obscure-overlay__clearOverlay";
var _3 = "tjs-obscure-overlay__isActive";
var _4 = "tjs-obscure-overlay__leftOverlay";
var _5 = "tjs-obscure-overlay__rightOverlay";
var _6 = "tjs-obscure-overlay__topOverlay";
export { _1 as "bottomOverlay", _2 as "clearOverlay", _3 as "isActive", _4 as "leftOverlay", _5 as "rightOverlay", _6 as "topOverlay" }
export default { "bottomOverlay": _1, "clearOverlay": _2, "isActive": _3, "leftOverlay": _4, "rightOverlay": _5, "topOverlay": _6 }
